<button
  type="button"
  ngpCheckbox
  ngpFocus
  [id]="effectiveId"
  [ngpCheckboxChecked]="isChecked"
  [ngpCheckboxIndeterminate]="indeterminate"
  [ngpCheckboxDisabled]="isDisabled()"
  [attr.aria-invalid]="errorState ? 'true' : null"
  (ngpCheckboxCheckedChange)="onCheckedChange($event)"
  (ngpCheckboxIndeterminateChange)="onIndeterminateChange($event)"
  (blur)="markTouched()"
>
  <span class="indicator" aria-hidden="true"></span>
  <ng-content />
</button>
